export default __webpack_public_path__ + "static/media/Logo.802e205d.png";